module.exports = __webpack_public_path__ + "static/logo5-6fd4215db8ee62b969235063727fd812.jpg";